import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface GetFlashStatusResponse extends MiddlewareAPIResponse
{
    getFlashStatus(): string;
}

export class GetFlashStatusResponseDtoImpl extends MiddlewareDtoImpl implements GetFlashStatusResponse
{
    private getGetFlashStatusDto : string;

    getFlashStatus(): string
    {
        return this.getGetFlashStatusDto;
    }

    setFlashStatus(getGetFlashStatusDto: string)
    {
        this.getGetFlashStatusDto = getGetFlashStatusDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/getflashstatus/getflashstatusresponse.tsx